import React, { createContext, useState, useCallback } from "react";

export const BackendBaseUrl = "https://muftykarenew.pythonanywhere.com/";
export const FrontEndBaseUrl = "https://muftykare.com/";

export const SrinuPick = `${BackendBaseUrl}images/srinu.jpg`;
export const ShankarPick = `${BackendBaseUrl}images/shankar.jpg`;
export const NanaajiPick = `${BackendBaseUrl}images/nanaaji.jpg`;
export const SrinuId = "srinu@muftycare";
export const ShankarID = "shankar@muftycare";
export const NanaajiId = "nanaaji@muftycare";
export const CALLACTIONUMBER = "7075232425";
export const WhatsAppACTIONUMBER = "9542926041";
export const ORANGE = "#f97316";
export const ORANGE_HOVER = "#ea580c";
export const BG_LIGHT = "#f8fafc";
export const PREMIUM_SHADOW = "0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)";
export const CARD_SHADOW = "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)";
export const BLACK = "#0b0f14";
export const BLACK_ELEV = "#111827";
export const SUCCESS_GREEN = "#22c55e";
export const SUCCESS_GREEN_HOVER = "#16a34a";
export const ERROR_RED = "#ef4444";
export const ERROR_RED_HOVER = "#dc2626";

export interface UserData {
  id?: string;
  name?: string;
  pick?: string;
  phone?: string;
  [k: string]: unknown;
}

export interface AuthContextValue {
  isAuthinticated: boolean;
  login: () => void;
  logout: () => void;
  user_data: UserData;
  UpdateUser: (data: Partial<UserData>) => void;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [isAuthinticated, setAuthintication] = useState<boolean>(() => {
    const storedAuth = localStorage.getItem("isAuthenticated");
    try {
      return storedAuth ? JSON.parse(storedAuth) === true : false;
    } catch {
      return false;
    }
  });

  const [user_data, setUserData] = useState<UserData>(() => {
    const storedUserdata = localStorage.getItem("user_data");
    try {
      return storedUserdata ? (JSON.parse(storedUserdata) as UserData) : {};
    } catch {
      return {};
    }
  });

  const login = useCallback(() => {
    setAuthintication(true);
    localStorage.setItem("isAuthenticated", JSON.stringify(true));
  }, []);

  const logout = useCallback(() => {
    setAuthintication(false);
    setUserData({});
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("user_data");
  }, []);

  const UpdateUser = useCallback(
    (data: Partial<UserData>) => {
      const updated = { ...user_data, ...data };
      setUserData(updated);
      localStorage.setItem("user_data", JSON.stringify(updated));
    },
    [user_data]
  );

  const value: AuthContextValue = {
    isAuthinticated,
    login,
    logout,
    user_data,
    UpdateUser,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// Optional helper hook
export const useAuth = (): AuthContextValue => {
  const ctx = React.useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
